import { apiGet, apiPost, type ApiRequestOptions } from './client.js';

export interface SessionInfo {
  authenticated: true;
  source: 'session' | 'allowlist';
}

interface LoginRequestBody {
  password: string;
}

interface LoginResponse {
  authenticated: true;
  source?: 'session' | 'allowlist';
}

export const fetchSession = (options?: ApiRequestOptions) =>
  apiGet<SessionInfo>('/auth/me', options);

export const login = (password: string, options?: ApiRequestOptions) =>
  apiPost<LoginResponse, LoginRequestBody>('/auth/login', { password }, options);

export const logout = (options?: ApiRequestOptions) =>
  apiPost<void, undefined>('/auth/logout', undefined, options);
